<template>
  <div class="pengaturan-page">
    <!-- Header -->
    <div class="page-header">
      <div class="page-header-content">
        <!-- <div class="page-header-i">
          <i class="el-icon-setting"></i>
        </div> -->
        <div>
          <p class="page-header-title">Pengaturan</p>
          <p class="page-header-subtitle">Kelola pengaturan aplikasi atau sistem</p>
        </div>
      </div>
    </div>

    <!-- Settings with Sidebar -->
    <div class="settings-container">
      <!-- Sidebar Menu -->
      <div class="settings-sidebar">
        <el-menu :default-active="activeItem" class="sidebar-menu" @select="handleMenuSelect">
          <el-menu-item v-for="(item, index) in menuItems" :key="index" :index="item.index" @click="getViews(item, item.link)">
            <i :class="item.icon"></i>
            <span>{{ item.label }}</span>
          </el-menu-item>
          <!-- <el-menu-item index="general">
            <i class="el-icon-s-tools"></i>
            <span>Pengaturan Umum</span>
          </el-menu-item>
          <el-menu-item index="attendance">
            <i class="el-icon-time"></i>
            <span>Pengaturan Absensi</span>
          </el-menu-item>
          <el-menu-item index="notification">
            <i class="el-icon-bell"></i>
            <span>Pengaturan Notifikasi</span>
          </el-menu-item>
          <el-menu-item index="security">
            <i class="el-icon-lock"></i>
            <span>Pengaturan Keamanan</span>
          </el-menu-item>
          <el-menu-item index="system">
            <i class="el-icon-info"></i>
            <span>Informasi Sistem</span>
          </el-menu-item>
          <el-divider></el-divider>
          <el-menu-item index="profile">
            <i class="el-icon-user-solid"></i>
            <span>Profile Pegawai</span>
          </el-menu-item>
          <el-menu-item index="roles">
            <i class="el-icon-user"></i>
            <span>Role Management</span>
          </el-menu-item>
          <el-menu-item index="users">
            <i class="el-icon-s-custom"></i>
            <span>User Management</span>
          </el-menu-item>
          <el-menu-item index="menus">
            <i class="el-icon-menu"></i>
            <span>Menu Management</span>
          </el-menu-item> -->
        </el-menu>
      </div>

      <!-- Content Area -->
      <div class="settings-content">
        <!-- General Settings -->
        <div class="content-section">
          <!-- <div class="section-header">
            <h2>
              <i :class="menuItem.icon"></i>  
              {{ menuItem.label }}
            </h2>
          </div> -->
          <el-card class="settings-card" shadow="hover">
            <router-view></router-view>
            <!-- <p>Kelola pengaturan umum aplikasi di sini.</p> -->
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomeView",
  data() {
    return {
      activeItem: 'profile',
      menuItems: [
        // { index: 'profile', label: 'Profile Pegawai', icon: 'el-icon-user-solid', link: '/pengaturan' },
        // { index: 'general', label: 'Pengaturan Umum', icon: 'el-icon-s-tools', link: '/pengaturan/228VuA0te0H0' },
        // { index: 'attendance', label: 'Pengaturan Absensi', icon: 'el-icon-time', link: '/pengaturan/MH6b6L04ioB7' },
        // { index: 'notification', label: 'Pengaturan Notifikasi', icon: 'el-icon-bell', link: '/pengaturan/GtUF24246anD' },
        // { index: 'security', label: 'Pengaturan Keamanan', icon: 'el-icon-lock', link: '/pengaturan/0386YQcijg0B' },       
        { index: 'roles', label: 'Role Management', icon: 'el-icon-user', link: '/pengaturan/N9c0UU698qaY' },
        { index: 'users', label: 'User Management', icon: 'el-icon-s-custom', link: '/pengaturan/r2AFmK0x0vql' },
        { index: 'menus', label: 'Menu Management', icon: 'el-icon-menu', link: '/pengaturan/p4EpnB87mI7O' },
        // { index: 'system', label: 'Informasi Sistem', icon: 'el-icon-info', link: '/pengaturan/Y7K6MBnm9AuZ' },
        { index: 'version_mobile', label: 'Version Mobile', icon: 'el-icon-mobile-phone', link: '/pengaturan/p4EpnB87mI7' },
        { index: 'aplikasi', label: 'Aplikasi', icon: 'el-icon-setting', link: '/pengaturan/apl1kas1s3tt1ng' }
      ],
      menuItem: { index: 'profile', label: 'Profile Pegawai', icon: 'el-icon-user-solid', link: '/pengaturan/cs94nu7K9KNp' }
    };
  },
  mounted() {
    this.setActiveMenuFromRoute();
  },
  watch: {
    '$route.path': {
      handler() {
        this.setActiveMenuFromRoute();
      },
      immediate: true
    }
  },
  methods: {
    setActiveMenuFromRoute() {
      const currentPath = this.$route.path;
      const matchedItem = this.menuItems.find(item => item.link === currentPath);
      
      if (matchedItem) {
        this.menuItem = { 
          index: matchedItem.index, 
          label: matchedItem.label, 
          icon: matchedItem.icon, 
          link: matchedItem.link 
        };
        this.activeItem = matchedItem.index;
      }
    },
    getViews: function(item, value) {      
      if (this.$route.path !== value) {
        this.$router.push(value);
        this.menuItem = { index: item.index, label: item.label, icon: item.icon, link: item.link };
      }
    },
    handleMenuSelect(index) {
      this.activeSection = index
    }
  }
};
</script>
<style scoped>
/* Header Styles */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 32px;
  border-radius: 16px;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
}

.page-header-content {
  color: white;
  /* display: flex; */
  /* justify-content: flex-start; */
  /* align-items: center; */
}

.page-header-title {
  font-size: 30px;
  font-weight: 700;
  /* margin: 0 0 8px 0; */
  /* display: flex; */
  /* align-items: center; */
  /* gap: 12px; */
}

.page-header-subtitle {
  font-size: 16px;
  /* margin: 0; */
  /* opacity: 0.9; */
}

/* .page-header-i i {
  margin-right: 10px;
} */

/* .page-header-i i {
  font-size: 55px;
} */

/* Page Layout */
.pengaturan-page {
  padding: 24px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* Settings Container */
.settings-container {
  display: flex;
  gap: 24px;
  min-height: 600px;
}

/* Sidebar */
.settings-sidebar {
  width: 280px;
  flex-shrink: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.sidebar-menu {
  border: none;
  background: transparent;
}

.sidebar-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  font-size: 15px;
  transition: all 0.3s ease;
}

.sidebar-menu .el-menu-item i {
  margin-right: 12px;
  font-size: 18px;
  color: #667eea;
}

.sidebar-menu .el-menu-item:hover {
  background: #f5f7fa;
}

.sidebar-menu .el-menu-item.is-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
}

.sidebar-menu .el-menu-item.is-active i {
  color: white;
}

.sidebar-menu .el-divider {
  margin: 10px 0;
}

/* Content Area */
.settings-content {
  flex: 1;
  min-width: 0;
}

.content-section {
  animation: fadeIn 0.3s ease;
}

.section-header {
  margin-bottom: 20px;
}

.section-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-header h2 i {
  color: #667eea;
  font-size: 26px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>